import React from 'react';
import type { ClassName, Disabled } from 'interfaces/shared';
import { StyledDatePicker } from './style';
import { Form, type DatePickerProps as AntdDatePickerProps } from 'antd';
import { Icon } from '../icon';
import type { Dayjs } from 'dayjs';
import weekday from 'dayjs/plugin/weekday';
import localeData from 'dayjs/plugin/localeData';
import dayjs from 'dayjs';

dayjs.extend(weekday);
dayjs.extend(localeData);

export interface DatePickerProps extends Disabled, ClassName {
  size?: 'large' | 'middle' | 'small' | undefined;
  placeholder?: string;
  onChange?: (value: Dayjs | null, dateString: string) => void;
  disabled?: boolean;
  value?: Dayjs;
  picker?: any;
  format?: string;
  name?: string;
  label?: string;
  disabledDate?: AntdDatePickerProps['disabledDate'];
  initialValue?: any;
  showTime?: boolean;
  showNow?: boolean;
}

export const DatePicker = ({
  className,
  placeholder = '',
  onChange,
  disabled,
  value,
  size,
  picker,
  format = 'DD.MM.YYYY',
  name,
  label,
  disabledDate,
  initialValue,
  showTime,
  showNow = false,
}: DatePickerProps) => {
  const date = value ? dayjs(value) : value;

  return (
    <Form.Item name={name} label={label} initialValue={initialValue}>
      <StyledDatePicker
        suffixIcon={<Icon icon="calendar-days" baseClass="fa-regular" />}
        className={className}
        getPopupContainer={(triggerNode: HTMLElement) => triggerNode}
        placeholder={placeholder}
        onChange={onChange as any}
        disabled={disabled}
        value={date}
        size={size}
        format={format || 'DD.MM.YYYY'}
        picker={picker}
        disabledDate={disabledDate}
        showTime={showTime}
        showNow={showNow}
      />
    </Form.Item>
  );
};
